import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBubbleArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.335 6.5c.5 3 2.5 5.5 7 5.5h-24c6 0 7.5-2 10.5-5.5C12.255 4.845 14 2.628 15.445.753c.66-.856 2.176-.186 2.038.886-.224 1.745-.357 3.609-.148 4.861Z"
      fill="#F3F2E8"
    />
  </svg>
);
const Memo = memo(SvgBubbleArrow);
export default Memo;
